import { createAsyncThunk } from '@reduxjs/toolkit';
import FilesResource from 'api/service/FilesResource';

export const listShareableAccounts = createAsyncThunk(
  'files/listShareableAccounts',
  async (initialData, { rejectWithValue }) => {
    const filesResource = new FilesResource();
    const { query } = initialData;
    const { status, data } = await filesResource.shareableAccounts({ query, size: 100 });
    if (status === 200) {
      return data || [];
    }
    return rejectWithValue('Folder creation failed.');
  }
);
